import { render } from "./PathwaysQuestionSelfDesire.vue?vue&type=template&id=1ba01080"
import script from "./PathwaysQuestionSelfDesire.vue?vue&type=script&lang=js"
export * from "./PathwaysQuestionSelfDesire.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__